// extracted by mini-css-extract-plugin
module.exports = {"container":"_9ad0e0c","icon":"_1d47365","primaryText":"_fadf040","secondaryText":"_c1eb18a"};